<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
        <b-button
          class="left-right"
          type="is-success"
          icon-left="plus"
          :disabled="selectedPlant === null || employees.length === 0"
          @click="showCreateForm()"
        >
          Create New Activity
        </b-button>
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Start Date">
              <b-datepicker
                v-model="start"
                name="startdate"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Start date"
              />
            </b-field>
            <b-field label="End Date">
              <b-datepicker
                v-model="end"
                name="enddate"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="End date"
              />
            </b-field>
            <b-field v-if="user.group.plants && user.group.plants.length != 0" label="Plant">
              <b-select v-model="selectedPlant" icon="industry" expanded>
                <option v-for="plant in user.group.plants" :key="plant.id" :value="plant">
                  {{ plant.name }}
                </option>
              </b-select>
            </b-field>
            <b-field v-else label="Plant">
              <multiselect
                v-model="selectedPlant"
                :options="plants"
                :multiple="false"
                :close-on-select="true"
                placeholder="Pick plant"
                :custom-label="(obj) => obj.id + ' - ' + obj.name"
                track-by="name"
                style="min-width: 400px;"
              />
            </b-field>
          </b-field>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
          </b-field>
        </div>
      </div>
      <div
        v-for="(schedule, index) in schedules"
        :key="schedule.date"
        class="card pl-2 py-1"
        :style="{'margin-top': '2rem', 'padding-right': '0.75rem', 'border': '2px solid transparent', 'border-image-slice': '1', 'border-image': 'linear-gradient(to left, rgb(125, 125, 125), rgb(225, 225, 225)) 3'}"
      >
        <div :style="{'text-transform': 'capitalize'}">
          <b-button
            class="left-right mr-2"
            type="is-ghost"
            icon-left="edit"
            :style="{'display': 'block', 'position': 'absolute', 'right': '0', 'margin-top': '-10px'}"
            :disabled="isLoading"
            @click="() => {showEditForm(schedule)}"
          />
        </div>
        <div :style="{'text-transform': 'capitalize'}">
          {{ new Date(new Date(schedule.date.split('Z')[0]).toISOString().split('T')[0] + 'T00:00:00').toLocaleDateString("en-EN", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) }}
        </div>
        <div
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'background-color': 'rgba(190, 230, 250, 1)',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            AM
          </div>
          <div class="shift-activity">
            Absent
          </div>
          <div class="shift-activity">
            Manual
          </div>
          <div class="shift-activity">
            Machine
          </div>
          <div class="shift-activity">
            Repair
          </div>
          <div class="shift-activity">
            Doors
          </div>
          <div class="shift-activity">
            Forklift
          </div>
          <div class="shift-activity">
            Special
          </div>
          <div class="shift-activity-comment">
            Comment
          </div>
        </div>
        <div
          v-for="employee in schedule.AM"
          :key="'AM' + employee.name + index"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : '') }}
          </div>
          <div class="shift-activity">
            {{ employee.absent }}
          </div>
          <div class="shift-activity">
            {{ employee.washing }}
          </div>
          <div class="shift-activity">
            {{ employee.machine }}
          </div>
          <div class="shift-activity">
            {{ employee.repair }}
          </div>
          <div class="shift-activity">
            {{ employee.doors }}
          </div>
          <div class="shift-activity">
            {{ employee.forklift }}
          </div>
          <div class="shift-activity">
            {{ employee.special }}
          </div>
          <div class="shift-activity-comment">
            {{ employee.comment }}
          </div>
        </div>
        <div
          v-if="schedule.AM && schedule.AM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'border-top': '2px rgb(150, 150, 150) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.declared_hours') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amForklift === schedule.AM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.amForklift }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.AM && schedule.AM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.assigned_hours') }}
          </div>
          <div class="shift-activity">
            {{ schedule.AM.reduce((sum, element) => sum + (element.absent != 'no'), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.washing), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.machine), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.repair), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.doors), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amForklift === schedule.AM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.AM.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.AM.reduce((sum, element) => sum + parseFloat(element.special), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.AM && schedule.AM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.treated_material') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.AM && schedule.AM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.efficiency') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.amMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.amMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.amMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.amMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.amMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'background-color': 'rgba(150, 190, 210, 1)',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            PM
          </div>
          <div class="shift-activity">
            Absent
          </div>
          <div class="shift-activity">
            Manual
          </div>
          <div class="shift-activity">
            Machine
          </div>
          <div class="shift-activity">
            Repair
          </div>
          <div class="shift-activity">
            Doors
          </div>
          <div class="shift-activity">
            Forklift
          </div>
          <div class="shift-activity">
            Special
          </div>
          <div class="shift-activity-comment">
            Comment
          </div>
        </div>
        <div
          v-for="employee in schedule.PM"
          :key="'PM' + employee.name + index"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : '') }}
          </div>
          <div class="shift-activity">
            {{ employee.absent }}
          </div>
          <div class="shift-activity">
            {{ employee.washing }}
          </div>
          <div class="shift-activity">
            {{ employee.machine }}
          </div>
          <div class="shift-activity">
            {{ employee.repair }}
          </div>
          <div class="shift-activity">
            {{ employee.doors }}
          </div>
          <div class="shift-activity">
            {{ employee.forklift }}
          </div>
          <div class="shift-activity">
            {{ employee.special }}
          </div>
          <div class="shift-activity-comment">
            {{ employee.comment }}
          </div>
        </div>
        <div
          v-if="schedule.PM && schedule.PM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'border-top': '2px rgb(150, 150, 150) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.declared_hours') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmForklift === schedule.PM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.pmForklift }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.PM && schedule.PM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.assigned_hours') }}
          </div>
          <div class="shift-activity">
            {{ schedule.PM.reduce((sum, element) => sum + (element.absent != 'no'), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.washing), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.machine), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.repair), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.doors), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmForklift === schedule.PM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.forklift), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.PM.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.PM.reduce((sum, element) => sum + parseFloat(element.special), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.PM && schedule.PM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.treated_material') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.PM && schedule.PM.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.efficiency') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.pmMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.pmMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.pmMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.pmMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.pmMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'background-color': 'rgba(110, 150, 170, 1)',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            Night
          </div>
          <div class="shift-activity">
            Absent
          </div>
          <div class="shift-activity">
            Manual
          </div>
          <div class="shift-activity">
            Machine
          </div>
          <div class="shift-activity">
            Repair
          </div>
          <div class="shift-activity">
            Doors
          </div>
          <div class="shift-activity">
            Forklift
          </div>
          <div class="shift-activity">
            Special
          </div>
          <div class="shift-activity-comment">
            Comment
          </div>
        </div>
        <div
          v-for="employee in schedule.Night"
          :key="'Night' + employee.name + index"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : '') }}
          </div>
          <div class="shift-activity">
            {{ employee.absent }}
          </div>
          <div class="shift-activity">
            {{ employee.washing }}
          </div>
          <div class="shift-activity">
            {{ employee.machine }}
          </div>
          <div class="shift-activity">
            {{ employee.repair }}
          </div>
          <div class="shift-activity">
            {{ employee.doors }}
          </div>
          <div class="shift-activity">
            {{ employee.forklift }}
          </div>
          <div class="shift-activity">
            {{ employee.special }}
          </div>
          <div class="shift-activity-comment">
            {{ employee.comment }}
          </div>
        </div>
        <div
          v-if="schedule.Night && schedule.Night.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'border-top': '2px rgb(150, 150, 150) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.declared_hours') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightForklift === schedule.Night.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.nightForklift }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.Night && schedule.Night.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.assigned_hours') }}
          </div>
          <div class="shift-activity">
            {{ schedule.Night.reduce((sum, element) => sum + (element.absent != 'no'), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.washing), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.washing), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.machine), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.machine), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.repair), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.repair), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.doors), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.doors), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightForklift === schedule.Night.reduce((sum, element) => sum + parseFloat(element.forklift), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.forklift), 0) }}
          </div>
          <div class="shift-activity" :style="{ color: schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) === schedule.Night.reduce((sum, element) => sum + parseFloat(element.special), 0) ? '' : 'red' }">
            {{ schedule.Night.reduce((sum, element) => sum + parseFloat(element.special), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.Night && schedule.Night.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.treated_material') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity">
            {{ schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
        <div
          v-if="schedule.Night && schedule.Night.length > 0"
          :style="{
            'border': '1px rgb(190, 190, 190) solid',
            'display': 'flex',
            'justify-content': 'space-around'
          }"
        >
          <div class="shift-activity-name">
            {{ $t('pages.production_data.employee_schedule.efficiency') }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.nightMovements.filter((x) => { return x.operation === 'washing' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.nightMovements.filter((x) => { return x.operation === 'machineWash' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.nightMovements.filter((x) => { return x.operation === 'repair' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ (schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.nightMovements.filter((x) => { return x.operation === 'repair__door' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity">
            {{ '' }}
          </div>
          <div class="shift-activity">
            {{ (schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.num_crates), 0) / schedule.nightMovements.filter((x) => { return x.operation === 'special' }).reduce((sum, element) => sum + parseFloat(element.hours), 0) || 0).toFixed(1) }}
          </div>
          <div class="shift-activity-comment">
            {{ '' }}
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :key="modalKey"
      :can-cancel="['escape', 'x']"
      :active.sync="isCreatingSchedule"
      scroll="keep"
      has-modal-card
    >
      <form v-if="isCreatingSchedule" @submit.prevent="submitSchedule" @keydown.enter.prevent="">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Create or Edit Schedule
              <span v-if="selectedPlant" style="font-size:1rem; text-overflow: elipsis">{{ selectedPlant.name }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Date">
                <b-datepicker
                  v-model="newSchedule.date"
                  :first-day-of-week="1"
                  name="newdate"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                  @input="updateEmployeeList"
                />
              </b-field>
            </b-field>
            <div
              v-for="employee of createEmployees"
              :key="employee.id + 'new'"
              style="width: 10%"
            >
              <b-field grouped>
                <b-field style="margin-top: 0.7em;">
                  <multiselect
                    v-model="newSchedule.shift[employee.id]"
                    :options="['AM', 'PM', 'Night']"
                    :multiple="true"
                    :searchable="false"
                    :show-labels="false"
                    :close-on-select="false"
                  />
                </b-field>
                <b-field style="align-content: center; margin-top: 0.5em;">
                  {{ employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : '') }}
                </b-field>
              </b-field>
              <div>
                <b-field v-if="newSchedule.shift[employee.id].length <= 0" grouped>
                  <b-checkbox v-model="newSchedule.deleted[employee.id]">
                    No Shift?
                  </b-checkbox>
                </b-field>
                <b-field v-if="newSchedule.shift[employee.id].includes('AM')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      AM
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="newSchedule.AM.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="newSchedule.AM.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="newSchedule.AM.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="newSchedule.AM.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="newSchedule.AM.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="newSchedule.AM.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="newSchedule.AM.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="newSchedule.AM.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="newSchedule.AM.checked[employee.id]" />
                  </b-field>
                </b-field>
                <b-field v-if="newSchedule.shift[employee.id].includes('PM')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      PM
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="newSchedule.PM.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="newSchedule.PM.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="newSchedule.PM.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="newSchedule.PM.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="newSchedule.PM.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="newSchedule.PM.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="newSchedule.PM.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="newSchedule.PM.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="newSchedule.PM.checked[employee.id]" />
                  </b-field>
                </b-field>
                <b-field v-if="newSchedule.shift[employee.id].includes('Night')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      Night
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="newSchedule.Night.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="newSchedule.Night.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="newSchedule.Night.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="newSchedule.Night.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="newSchedule.Night.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="newSchedule.Night.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="newSchedule.Night.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="newSchedule.Night.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="newSchedule.Night.checked[employee.id]" />
                  </b-field>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal
      :key="modalKey2"
      :can-cancel="['escape', 'x']"
      :active.sync="isEditingSchedule"
      scroll="keep"
      has-modal-card
    >
      <form v-if="isEditingSchedule" @submit.prevent="submitEdit" @keydown.enter.prevent="">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Edit Schedule
              <span v-if="selectedPlant" style="font-size:1rem; text-overflow: elipsis">{{ selectedPlant.name }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Date">
                {{ editableSchedule.date }}
              </b-field>
            </b-field>
            <div
              v-for="employee of editableEmployees"
              :key="employee.id + 'new'"
              style="width: 10%"
            >
              <b-field grouped>
                <b-field style="margin-top: 0.7em;">
                  <multiselect
                    v-model="editableSchedule.shift[employee.id]"
                    :options="['AM', 'PM', 'Night']"
                    :multiple="true"
                    :searchable="false"
                    :show-labels="false"
                    :close-on-select="false"
                  />
                </b-field>
                <b-field style="align-content: center; margin-top: 0.5em;">
                  {{ employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : '') }}
                </b-field>
              </b-field>
              <div>
                <b-field v-if="editableSchedule.shift[employee.id].length <= 0" grouped>
                  <b-checkbox v-model="editableSchedule.deleted[employee.id]">
                    No Shift?
                  </b-checkbox>
                </b-field>
                <b-field v-if="editableSchedule.shift[employee.id].includes('AM')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      AM
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="editableSchedule.AM.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="editableSchedule.AM.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="editableSchedule.AM.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="editableSchedule.AM.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="editableSchedule.AM.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="editableSchedule.AM.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="editableSchedule.AM.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="editableSchedule.AM.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="editableSchedule.AM.checked[employee.id]" />
                  </b-field>
                </b-field>
                <b-field v-if="editableSchedule.shift[employee.id].includes('PM')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      PM
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="editableSchedule.PM.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="editableSchedule.PM.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="editableSchedule.PM.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="editableSchedule.PM.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="editableSchedule.PM.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="editableSchedule.PM.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="editableSchedule.PM.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="editableSchedule.PM.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="editableSchedule.PM.checked[employee.id]" />
                  </b-field>
                </b-field>
                <b-field v-if="editableSchedule.shift[employee.id].includes('Night')" grouped>
                  <b-field label="ᅟ">
                    <b-field style="font-weight: bold; width: 5ch;">
                      Night
                    </b-field>
                  </b-field>
                  <b-field label="Manual">
                    <b-input
                      v-model="editableSchedule.Night.washing[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Machine">
                    <b-input
                      v-model="editableSchedule.Night.machine[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Repair">
                    <b-input
                      v-model="editableSchedule.Night.repair[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Doors">
                    <b-input
                      v-model="editableSchedule.Night.doors[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Forklift">
                    <b-input
                      v-model="editableSchedule.Night.forklift[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Special">
                    <b-input
                      v-model="editableSchedule.Night.special[employee.id]"
                      type="number"
                      min="0"
                      max="12"
                      step="0.01"
                      style="width: 5em;"
                    />
                  </b-field>
                  <b-field label="Comment">
                    <b-input
                      v-model="editableSchedule.Night.comment[employee.id]"
                      type="text"
                      style="width: 10em;"
                    />
                  </b-field>
                  <b-field label="Absence">
                    <b-select v-model="editableSchedule.Night.absence[employee.id]" style="width: 6em;">
                      <option value="no">
                        No
                      </option>
                      <option value="AL">
                        Annual Leave
                      </option>
                      <option value="ML">
                        Medical Leave
                      </option>
                      <option value="AB">
                        Absence
                      </option>
                    </b-select>
                  </b-field>
                  <b-field label="ᅟ" style="align-content: center;">
                    <b-checkbox v-model="editableSchedule.Night.checked[employee.id]" />
                  </b-field>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Plant from '../../services/v2/plant'
import { v4 as uuidv4 } from 'uuid'
import EmployeeSchedule from '../../services/v3/employeeSchedule'

export default {
  name: 'EmployeeSchedule',
  components: {
  },
  data: function () {
    return {
      editableSchedule: null,
      newSchedule: null,
      start: null,
      end: new Date(),
      selectedPlant: JSON.parse(sessionStorage.getItem('consultingPlant')),
      isLoading: false,
      isCreatingSchedule: false,
      isEditingSchedule: false,
      plants: [],
      schedules: [],
      employees: [],
      createEmployees: [],
      editableEmployees: [],
      modalKey: 0,
      modalKey2: 'a'
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    this.start = new Date()
    this.start.setDate(new Date().getDate() - 1)
    if (this.user.group.plants.length === 0) {
      this.plants = await Plant.getAll()
      this.plants = this.plants.filter((x) => {
        return !(x.id[0] === 'F' && x.id[1] === 'R' && x.id[2] === 'Z')
      })
    }
  },
  methods: {
    resetData () {
      this.employees = []
      this.schedules = []
      this.editableSchedule = null
      this.createEmployees = []
      this.editableEmployees = []
      this.newSchedule = null
    },
    showCreateForm () {
      this.isCreatingSchedule = true
      this.newSchedule = {
        date: new Date(new Date().toLocaleDateString('en-CA')),
        shift: [],
        deleted: [],
        siteId: this.selectedPlant.id,
        AM: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        },
        PM: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        },
        Night: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        }
      }
      this.newSchedule.date.setDate(new Date().getDate() - 1)
      this.createEmployees = this.employees.filter((x) => {
        var a = true
        var b = true
        if (x.date_entree) {
          if (!(x.date_entree <= this.newSchedule.date.toLocaleDateString('en-CA'))) {
            a = false
          }
        }
        if (x.date_sortie) {
          if (!(x.date_sortie >= this.newSchedule.date.toLocaleDateString('en-CA'))) {
            b = false
          }
        }
        return a && b
      })
      this.employees.forEach((employee) => {
        this.newSchedule.shift[employee.id] = []
        if (employee.last_shift.AM && (employee.last_shift.AM.doors !== 0 || employee.last_shift.AM.forklift !== 0 || employee.last_shift.AM.machine !== 0 || employee.last_shift.AM.repair !== 0 || employee.last_shift.AM.special !== 0 || employee.last_shift.AM.washing !== 0)) {
          this.newSchedule.shift[employee.id].push('AM')
        }
        if (employee.last_shift.PM && (employee.last_shift.PM.doors !== 0 || employee.last_shift.PM.forklift !== 0 || employee.last_shift.PM.machine !== 0 || employee.last_shift.PM.repair !== 0 || employee.last_shift.PM.special !== 0 || employee.last_shift.PM.washing !== 0)) {
          this.newSchedule.shift[employee.id].push('PM')
        }
        if (employee.last_shift.Night && (employee.last_shift.Night.doors !== 0 || employee.last_shift.Night.forklift !== 0 || employee.last_shift.Night.machine !== 0 || employee.last_shift.Night.repair !== 0 || employee.last_shift.Night.special !== 0 || employee.last_shift.Night.washing !== 0)) {
          this.newSchedule.shift[employee.id].push('Night')
        }
        this.newSchedule.AM.washing[employee.id] = employee.last_shift.AM.washing
        this.newSchedule.AM.machine[employee.id] = employee.last_shift.AM.machine
        this.newSchedule.AM.repair[employee.id] = employee.last_shift.AM.repair
        this.newSchedule.AM.doors[employee.id] = employee.last_shift.AM.doors
        this.newSchedule.AM.forklift[employee.id] = employee.last_shift.AM.forklift
        this.newSchedule.AM.special[employee.id] = employee.last_shift.AM.special
        this.newSchedule.AM.comment[employee.id] = employee.last_shift.AM.comment
        this.newSchedule.AM.absence[employee.id] = 'no'
        this.newSchedule.AM.checked[employee.id] = false
        this.newSchedule.PM.washing[employee.id] = employee.last_shift.PM.washing
        this.newSchedule.PM.machine[employee.id] = employee.last_shift.PM.machine
        this.newSchedule.PM.repair[employee.id] = employee.last_shift.PM.repair
        this.newSchedule.PM.doors[employee.id] = employee.last_shift.PM.doors
        this.newSchedule.PM.forklift[employee.id] = employee.last_shift.PM.forklift
        this.newSchedule.PM.special[employee.id] = employee.last_shift.PM.special
        this.newSchedule.PM.comment[employee.id] = employee.last_shift.PM.comment
        this.newSchedule.PM.absence[employee.id] = 'no'
        this.newSchedule.PM.checked[employee.id] = false
        this.newSchedule.Night.washing[employee.id] = employee.last_shift.Night.washing
        this.newSchedule.Night.machine[employee.id] = employee.last_shift.Night.machine
        this.newSchedule.Night.repair[employee.id] = employee.last_shift.Night.repair
        this.newSchedule.Night.doors[employee.id] = employee.last_shift.Night.doors
        this.newSchedule.Night.forklift[employee.id] = employee.last_shift.Night.forklift
        this.newSchedule.Night.special[employee.id] = employee.last_shift.Night.special
        this.newSchedule.Night.comment[employee.id] = employee.last_shift.Night.comment
        this.newSchedule.Night.absence[employee.id] = 'no'
        this.newSchedule.Night.checked[employee.id] = false
        this.newSchedule.deleted[employee.id] = false
      })
    },
    updateEmployeeList () {
      if (this.newSchedule.date) {
        this.createEmployees = this.employees.filter((x) => {
          var a = true
          var b = true
          if (x.date_entree) {
            if (!(x.date_entree <= this.newSchedule.date.toLocaleDateString('en-CA'))) {
              a = false
            }
          }
          if (x.date_sortie) {
            if (!(x.date_sortie >= this.newSchedule.date.toLocaleDateString('en-CA'))) {
              b = false
            }
          }
          return a && b
        })
        this.modalKey += 1
      }
    },
    generateUserId () {
      this.newSchedule.matricule = uuidv4()
    },
    showEditForm (schedule) {
      this.isEditingSchedule = true
      this.editableSchedule = {
        AM: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        },
        PM: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        },
        Night: {
          washing: [],
          machine: [],
          repair: [],
          doors: [],
          forklift: [],
          special: [],
          comment: [],
          absence: [],
          checked: []
        },
        shift: [],
        deleted: [],
        siteId: this.selectedPlant.id,
        date: schedule.date
      }
      if (this.editableSchedule.date) {
        this.editableEmployees = this.employees.filter((x) => {
          var a = true
          var b = true
          if (x.date_entree) {
            if (!(x.date_entree <= this.editableSchedule.date)) {
              a = false
            }
          }
          if (x.date_sortie) {
            if (!(x.date_sortie >= this.editableSchedule.date)) {
              b = false
            }
          }
          return a && b
        })
        this.modalKey2 += 'a'
        this.editableSchedule.shift = []
        this.editableEmployees.forEach((employee) => {
          this.editableSchedule.shift[employee.id] = []
          this.editableSchedule.deleted[employee.id] = false
          let amBuffer = schedule.AM.filter(x => { return x.employeeId === employee.id })
          if (amBuffer.length > 0) {
            this.editableSchedule.shift[employee.id].push('AM')
            this.editableSchedule.AM.washing[employee.id] = amBuffer[0].washing
            this.editableSchedule.AM.machine[employee.id] = amBuffer[0].machine
            this.editableSchedule.AM.repair[employee.id] = amBuffer[0].repair
            this.editableSchedule.AM.doors[employee.id] = amBuffer[0].doors
            this.editableSchedule.AM.forklift[employee.id] = amBuffer[0].forklift
            this.editableSchedule.AM.special[employee.id] = amBuffer[0].special
            this.editableSchedule.AM.comment[employee.id] = amBuffer[0].comment
            this.editableSchedule.AM.absence[employee.id] = 'no'
            this.editableSchedule.AM.checked[employee.id] = false
          } else {
            this.editableSchedule.AM.washing[employee.id] = 0
            this.editableSchedule.AM.machine[employee.id] = 0
            this.editableSchedule.AM.repair[employee.id] = 0
            this.editableSchedule.AM.doors[employee.id] = 0
            this.editableSchedule.AM.forklift[employee.id] = 0
            this.editableSchedule.AM.special[employee.id] = 0
            this.editableSchedule.AM.comment[employee.id] = 0
            this.editableSchedule.AM.absence[employee.id] = 'no'
            this.editableSchedule.AM.checked[employee.id] = false
          }
          let pmBuffer = schedule.PM.filter(x => { return x.employeeId === employee.id })
          if (pmBuffer.length > 0) {
            this.editableSchedule.shift[employee.id].push('PM')
            this.editableSchedule.PM.washing[employee.id] = pmBuffer[0].washing
            this.editableSchedule.PM.machine[employee.id] = pmBuffer[0].machine
            this.editableSchedule.PM.repair[employee.id] = pmBuffer[0].repair
            this.editableSchedule.PM.doors[employee.id] = pmBuffer[0].doors
            this.editableSchedule.PM.forklift[employee.id] = pmBuffer[0].forklift
            this.editableSchedule.PM.special[employee.id] = pmBuffer[0].special
            this.editableSchedule.PM.comment[employee.id] = pmBuffer[0].comment
            this.editableSchedule.PM.absence[employee.id] = 'no'
            this.editableSchedule.PM.checked[employee.id] = false
          } else {
            this.editableSchedule.PM.washing[employee.id] = 0
            this.editableSchedule.PM.machine[employee.id] = 0
            this.editableSchedule.PM.repair[employee.id] = 0
            this.editableSchedule.PM.doors[employee.id] = 0
            this.editableSchedule.PM.forklift[employee.id] = 0
            this.editableSchedule.PM.special[employee.id] = 0
            this.editableSchedule.PM.comment[employee.id] = 0
            this.editableSchedule.PM.absence[employee.id] = 'no'
            this.editableSchedule.PM.checked[employee.id] = false
          }
          let nightBuffer = schedule.Night.filter(x => { return x.employeeId === employee.id })
          if (nightBuffer.length > 0) {
            this.editableSchedule.shift[employee.id].push('Night')
            this.editableSchedule.Night.washing[employee.id] = nightBuffer[0].washing
            this.editableSchedule.Night.machine[employee.id] = nightBuffer[0].machine
            this.editableSchedule.Night.repair[employee.id] = nightBuffer[0].repair
            this.editableSchedule.Night.doors[employee.id] = nightBuffer[0].doors
            this.editableSchedule.Night.forklift[employee.id] = nightBuffer[0].forklift
            this.editableSchedule.Night.special[employee.id] = nightBuffer[0].special
            this.editableSchedule.Night.comment[employee.id] = nightBuffer[0].comment
            this.editableSchedule.Night.absence[employee.id] = 'no'
            this.editableSchedule.Night.checked[employee.id] = false
          } else {
            this.editableSchedule.Night.washing[employee.id] = 0
            this.editableSchedule.Night.machine[employee.id] = 0
            this.editableSchedule.Night.repair[employee.id] = 0
            this.editableSchedule.Night.doors[employee.id] = 0
            this.editableSchedule.Night.forklift[employee.id] = 0
            this.editableSchedule.Night.special[employee.id] = 0
            this.editableSchedule.Night.comment[employee.id] = 0
            this.editableSchedule.Night.absence[employee.id] = 'no'
            this.editableSchedule.Night.checked[employee.id] = false
          }
        })
      }
    },
    async getData () {
      if (!this.selectedPlant || !this.selectedPlant.id) {
        this.$buefy.toast.open({ message: 'Please select a plant', duration: 3000, type: 'is-danger' })
        return
      }
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      this.isLoading = true
      try {
        const data = await EmployeeSchedule.getTable({
          start: this.start.toLocaleDateString('en-CA'),
          end: this.end.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id
        })
        data.employees.forEach(element => {
          this.employees.push({
            id: element.id,
            id_site: element.id_site,
            name: element.name,
            matricule: element.matricule,
            title: element.title,
            surname: element.surname,
            date_entree: element.date_entree ? new Date(element.date_entree.split('Z')[0]).toLocaleDateString('en-CA') : null,
            date_sortie: element.date_sortie ? new Date(element.date_sortie.split('Z')[0]).toLocaleDateString('en-CA') : null,
            last_shift: element.lastShift
          })
        })
        this.employees.sort(function (a, b) {
          if (a.surname.toLowerCase() + a.name.toLowerCase() < b.surname.toLowerCase() + b.name.toLowerCase()) {
            return -1
          }
          if (a.surname.toLowerCase() + a.name.toLowerCase() > b.surname.toLowerCase() + b.name.toLowerCase()) {
            return 1
          }
          return 0
        })

        for (var d = new Date(new Date(this.start.toLocaleDateString('en-CA')).toISOString().split('T')[0] + 'T00:00:00'); d <= new Date(new Date(this.end.toLocaleDateString('en-CA')).toISOString().split('T')[0] + 'T00:00:00'); d.setDate(d.getDate() + 1)) {
          let tempSchedule = {
            date: d.toLocaleDateString('en-CA'),
            AM: [],
            PM: [],
            Night: [],
            amMovements: [],
            pmMovements: [],
            nightMovements: [],
            amForklift: 0,
            pmForklift: 0,
            nightForklift: 0
          }
          this.employees.forEach((employee) => {
            let employeeSchedule = data.schedules.filter((x) => {
              return new Date(x.date.split('Z')[0]).toLocaleDateString('en-CA') === d.toLocaleDateString('en-CA') && x.id_employee === employee.id
            })
            tempSchedule.AM.push({
              name: employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : ''),
              employeeId: employee.id,
              absent: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity.split('__')[0] === 'absent'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'AM' && x.activity.split('__')[0] === 'absent'
                })[0].activity.split('__')[1] : 'no',
              washing: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'washing'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              machine: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'machineWash'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              repair: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'repair'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              doors: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'repair__door'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              forklift: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'forklift'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              special: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'special'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              comment: employeeSchedule.filter((x) => {
                return x.shift === 'AM' && x.activity === 'comment'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'AM' && x.activity === 'comment'
                })[0].comment : null
            })
            tempSchedule.PM.push({
              name: employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : ''),
              employeeId: employee.id,
              absent: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity.split('__')[0] === 'absent'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'PM' && x.activity.split('__')[0] === 'absent'
                })[0].activity.split('__')[1] : 'no',
              washing: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'washing'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              machine: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'machineWash'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              repair: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'repair'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              doors: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'repair__door'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              forklift: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'forklift'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              special: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'special'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              comment: employeeSchedule.filter((x) => {
                return x.shift === 'PM' && x.activity === 'comment'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'PM' && x.activity === 'comment'
                })[0].comment : null
            })
            tempSchedule.Night.push({
              name: employee.name + (employee.surname && employee.surname.length > 0 ? ' ' + employee.surname : ''),
              employeeId: employee.id,
              absent: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity.split('__')[0] === 'absent'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'Night' && x.activity.split('__')[0] === 'absent'
                })[0].activity.split('__')[1] : 'no',
              washing: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'washing'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              machine: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'machineWash'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              repair: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'repair'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              doors: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'repair__door'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              forklift: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'forklift'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              special: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'special'
              }).reduce((sum, element) => sum + parseFloat(element.hours), 0),
              comment: employeeSchedule.filter((x) => {
                return x.shift === 'Night' && x.activity === 'comment'
              }).length > 0 ? employeeSchedule.filter((x) => {
                  return x.shift === 'Night' && x.activity === 'comment'
                })[0].comment : null
            })
          })
          tempSchedule.amMovements = data.movements.filter((x) => {
            return new Date(x.date.split('Z')[0]).toLocaleDateString('en-CA') === d.toLocaleDateString('en-CA') && x.shift === 'AM'
          })
          tempSchedule.pmMovements = data.movements.filter((x) => {
            return new Date(x.date.split('Z')[0]).toLocaleDateString('en-CA') === d.toLocaleDateString('en-CA') && x.shift === 'PM'
          })
          tempSchedule.nightMovements = data.movements.filter((x) => {
            return new Date(x.date.split('Z')[0]).toLocaleDateString('en-CA') === d.toLocaleDateString('en-CA') && x.shift === 'Night'
          })
          tempSchedule.AM = tempSchedule.AM.filter((x) => {
            return x.absent !== 'no' || x.washing > 0 || x.machine > 0 || x.repair > 0 || x.doors > 0 || x.forklift > 0 || x.special > 0
          })
          tempSchedule.PM = tempSchedule.PM.filter((x) => {
            return x.absent !== 'no' || x.washing > 0 || x.machine > 0 || x.repair > 0 || x.doors > 0 || x.forklift > 0 || x.special > 0
          })
          tempSchedule.Night = tempSchedule.Night.filter((x) => {
            return x.absent !== 'no' || x.washing > 0 || x.machine > 0 || x.repair > 0 || x.doors > 0 || x.forklift > 0 || x.special > 0
          })
          let forkliftTypeBuffer = [...new Set(tempSchedule.amMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).map(x => x.status_crate_start.split('__')[0]))]
          forkliftTypeBuffer.forEach((forkliftType) => {
            let typeMoves = tempSchedule.amMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' && x.status_crate_start.split('__')[0] === forkliftType })
            typeMoves = typeMoves.reduce((prev, current) => (prev && prev.hours > current.hours) ? prev : current, null)
            tempSchedule.amForklift += typeMoves ? typeMoves.hours : 0
          })
          forkliftTypeBuffer = [...new Set(tempSchedule.pmMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).map(x => x.status_crate_start.split('__')[0]))]
          forkliftTypeBuffer.forEach((forkliftType) => {
            let typeMoves = tempSchedule.pmMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' && x.status_crate_start.split('__')[0] === forkliftType })
            typeMoves = typeMoves.reduce((prev, current) => (prev && prev.hours > current.hours) ? prev : current, null)
            tempSchedule.pmForklift += typeMoves ? typeMoves.hours : 0
          })
          forkliftTypeBuffer = [...new Set(tempSchedule.nightMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' }).map(x => x.status_crate_start.split('__')[0]))]
          forkliftTypeBuffer.forEach((forkliftType) => {
            let typeMoves = tempSchedule.nightMovements.filter((x) => { return x.operation.split('__')[0] === 'forklift' && x.status_crate_start.split('__')[0] === forkliftType })
            typeMoves = typeMoves.reduce((prev, current) => (prev && prev.hours > current.hours) ? prev : current, null)
            tempSchedule.nightForklift += typeMoves ? typeMoves.hours : 0
          })
          this.schedules.push(tempSchedule)
        }
        if (this.employees.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No corresponding employees found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.isLoading = false
    },
    submitSchedule () {
      this.isCreatingSchedule = false
      this.$buefy.toast.open({ message: 'Submitting data, Please wait a few seconds before refreshing.', duration: 3000, type: 'is-success' })
      this.createEmployees.forEach(async (employee) => {
        try {
          if (this.newSchedule.deleted[employee.id]) {
            await EmployeeSchedule.archiveAllSchedules(employee.id, this.newSchedule.date.toLocaleDateString('en-CA'))
          }
          if (this.newSchedule.AM.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.newSchedule.date.toLocaleDateString('en-CA'), 'AM')
            if (this.newSchedule.AM.washing[employee.id] && this.newSchedule.AM.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'washing',
                  hours: this.newSchedule.AM.washing[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.machine[employee.id] && this.newSchedule.AM.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'machineWash',
                  hours: this.newSchedule.AM.machine[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.repair[employee.id] && this.newSchedule.AM.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair',
                  hours: this.newSchedule.AM.repair[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.doors[employee.id] && this.newSchedule.AM.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair__door',
                  hours: this.newSchedule.AM.doors[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.forklift[employee.id] && this.newSchedule.AM.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'forklift',
                  hours: this.newSchedule.AM.forklift[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.special[employee.id] && this.newSchedule.AM.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'special',
                  hours: this.newSchedule.AM.special[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.comment[employee.id] && this.newSchedule.AM.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'comment',
                  comment: this.newSchedule.AM.comment[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.AM.absence[employee.id] && this.newSchedule.AM.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'absent__' + this.newSchedule.AM.absence[employee.id],
                  hours: 0,
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
          }
          if (this.newSchedule.PM.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.newSchedule.date.toLocaleDateString('en-CA'), 'PM')
            if (this.newSchedule.PM.washing[employee.id] && this.newSchedule.PM.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'washing',
                  hours: this.newSchedule.PM.washing[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.machine[employee.id] && this.newSchedule.PM.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'machineWash',
                  hours: this.newSchedule.PM.machine[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.repair[employee.id] && this.newSchedule.PM.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair',
                  hours: this.newSchedule.PM.repair[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.doors[employee.id] && this.newSchedule.PM.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair__door',
                  hours: this.newSchedule.PM.doors[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.forklift[employee.id] && this.newSchedule.PM.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'forklift',
                  hours: this.newSchedule.PM.forklift[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.special[employee.id] && this.newSchedule.PM.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'special',
                  hours: this.newSchedule.PM.special[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.comment[employee.id] && this.newSchedule.PM.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'comment',
                  comment: this.newSchedule.PM.comment[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.PM.absence[employee.id] && this.newSchedule.PM.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'absent__' + this.newSchedule.PM.absence[employee.id],
                  hours: 0,
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
          }
          if (this.newSchedule.Night.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.newSchedule.date.toLocaleDateString('en-CA'), 'Night')
            if (this.newSchedule.Night.washing[employee.id] && this.newSchedule.Night.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'washing',
                  hours: this.newSchedule.Night.washing[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.machine[employee.id] && this.newSchedule.Night.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'machineWash',
                  hours: this.newSchedule.Night.machine[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.repair[employee.id] && this.newSchedule.Night.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair',
                  hours: this.newSchedule.Night.repair[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.doors[employee.id] && this.newSchedule.Night.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'repair__door',
                  hours: this.newSchedule.Night.doors[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.forklift[employee.id] && this.newSchedule.Night.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'forklift',
                  hours: this.newSchedule.Night.forklift[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.special[employee.id] && this.newSchedule.Night.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'special',
                  hours: this.newSchedule.Night.special[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.comment[employee.id] && this.newSchedule.Night.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'comment',
                  comment: this.newSchedule.Night.comment[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.newSchedule.Night.absence[employee.id] && this.newSchedule.Night.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.newSchedule.siteId,
                  date: this.newSchedule.date.toLocaleDateString('en-CA'),
                  activity: 'absent__' + this.newSchedule.Night.absence[employee.id],
                  hours: 0,
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
          }
        } catch (error) {
          this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        }
      })
    },
    submitEdit () {
      this.isEditingSchedule = false
      this.$buefy.toast.open({ message: 'Submitting data, Please wait a few seconds before refreshing.', duration: 3000, type: 'is-success' })
      this.editableEmployees.forEach(async (employee) => {
        try {
          if (this.editableSchedule.deleted[employee.id]) {
            await EmployeeSchedule.archiveAllSchedules(employee.id, this.editableSchedule.date)
          }
          if (this.editableSchedule.AM.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.editableSchedule.date, 'AM')
            if (this.editableSchedule.AM.washing[employee.id] && this.editableSchedule.AM.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'washing',
                  hours: this.editableSchedule.AM.washing[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.machine[employee.id] && this.editableSchedule.AM.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'machineWash',
                  hours: this.editableSchedule.AM.machine[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.repair[employee.id] && this.editableSchedule.AM.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair',
                  hours: this.editableSchedule.AM.repair[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.doors[employee.id] && this.editableSchedule.AM.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair__door',
                  hours: this.editableSchedule.AM.doors[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.forklift[employee.id] && this.editableSchedule.AM.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'forklift',
                  hours: this.editableSchedule.AM.forklift[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.special[employee.id] && this.editableSchedule.AM.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'special',
                  hours: this.editableSchedule.AM.special[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.comment[employee.id] && this.editableSchedule.AM.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'comment',
                  comment: this.editableSchedule.AM.comment[employee.id],
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.AM.absence[employee.id] && this.editableSchedule.AM.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'absent__' + this.editableSchedule.AM.absence[employee.id],
                  hours: 0,
                  shift: 'AM',
                  id_employee: employee.id
                }
              )
            }
          }
          if (this.editableSchedule.PM.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.editableSchedule.date, 'PM')
            if (this.editableSchedule.PM.washing[employee.id] && this.editableSchedule.PM.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'washing',
                  hours: this.editableSchedule.PM.washing[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.machine[employee.id] && this.editableSchedule.PM.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'machineWash',
                  hours: this.editableSchedule.PM.machine[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.repair[employee.id] && this.editableSchedule.PM.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair',
                  hours: this.editableSchedule.PM.repair[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.doors[employee.id] && this.editableSchedule.PM.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair__door',
                  hours: this.editableSchedule.PM.doors[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.forklift[employee.id] && this.editableSchedule.PM.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'forklift',
                  hours: this.editableSchedule.PM.forklift[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.special[employee.id] && this.editableSchedule.PM.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'special',
                  hours: this.editableSchedule.PM.special[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.comment[employee.id] && this.editableSchedule.PM.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'comment',
                  comment: this.editableSchedule.PM.comment[employee.id],
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.PM.absence[employee.id] && this.editableSchedule.PM.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'absent__' + this.editableSchedule.PM.absence[employee.id],
                  hours: 0,
                  shift: 'PM',
                  id_employee: employee.id
                }
              )
            }
          }
          if (this.editableSchedule.Night.checked[employee.id]) {
            await EmployeeSchedule.archiveShiftSchedules(employee.id, this.editableSchedule.date, 'Night')
            if (this.editableSchedule.Night.washing[employee.id] && this.editableSchedule.Night.washing[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'washing',
                  hours: this.editableSchedule.Night.washing[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.machine[employee.id] && this.editableSchedule.Night.machine[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'machineWash',
                  hours: this.editableSchedule.Night.machine[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.repair[employee.id] && this.editableSchedule.Night.repair[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair',
                  hours: this.editableSchedule.Night.repair[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.doors[employee.id] && this.editableSchedule.Night.doors[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'repair__door',
                  hours: this.editableSchedule.Night.doors[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.forklift[employee.id] && this.editableSchedule.Night.forklift[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'forklift',
                  hours: this.editableSchedule.Night.forklift[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.special[employee.id] && this.editableSchedule.Night.special[employee.id] > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'special',
                  hours: this.editableSchedule.Night.special[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.comment[employee.id] && this.editableSchedule.Night.comment[employee.id].length > 0) {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'comment',
                  comment: this.editableSchedule.Night.comment[employee.id],
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
            if (this.editableSchedule.Night.absence[employee.id] && this.editableSchedule.Night.absence[employee.id] !== 'no') {
              EmployeeSchedule.createSchedule(
                {
                  siteId: this.editableSchedule.siteId,
                  date: this.editableSchedule.date,
                  activity: 'absent__' + this.editableSchedule.Night.absence[employee.id],
                  hours: 0,
                  shift: 'Night',
                  id_employee: employee.id
                }
              )
            }
          }
        } catch (error) {
          this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        }
      })
    }
  }
}

</script>

<style scoped>

.shift-activity {
  border-left: 1px rgb(190, 190, 190) solid;
  width: 30%;
  text-align: center;
}

.shift-activity-name {
  border-left: 1px rgb(190, 190, 190) solid;
  width: 100%;
  text-align: center;
}

.shift-activity-comment {
  border-left: 1px rgb(190, 190, 190) solid;
  width: 100%;
  text-align: center;
}

</style>
